import React from "react";
import { ArrowBackCircle } from 'react-ionicons'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@popperjs/core"
import { Modal } from 'react-bootstrap';
import constantURI from "../URI"
import _post from "../Functions/Post"
import stylesMed from "./stylesMed"
import DatePicker from "react-datepicker";
import Authenticate from "../Functions/MedRepAuthenticate"

export default class AddVisit extends React.Component {

    constructor() {
        super();
        this.state = {
            showAlerBack: false,
            Reps: [],
            user: "",
            selectedRep: 0,
            token: "",
            date: new Date(),
            skills: [],
            remark: "",
            selectedSkill: 0,
            currentRep: 0,
            coachCount: 0,
            USCoach: [],
            disableSync: false,
            disableSave: false,
            USCoach2: [],
            authenticate: false,
            alertUndefined: false
        }
    }

    async componentDidMount() {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        const user = localStorage.getItem("User");
        const token = localStorage.getItem("Token");
        const coachCount = localStorage.getItem('UnsyncedCoachCount');
        const coach = localStorage.getItem('UnsyncedCoach');
        await this.setState({ user: JSON.parse(user), token: JSON.parse(token), coachCount: JSON.parse(coachCount), USCoach: JSON.parse(coach) });

        const readURL = constantURI() + "odooController/MedRepRead";
        const RepsBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.users",
                "args": [],
                "kwargs": {
                    "fields": ["name", "supervisor"],
                    "domain": [["supervisor", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        const currentRepBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "res.users",
                "args": [],
                "kwargs": {
                    "fields": ["name", "supervisor"],
                    "domain": [["name", "=", this.state.user]]
                }
            },
            "token": this.state.token
        }
        const skillsBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "search_read",
                "model": "coachingskills",
                "args": [],
                "kwargs": {
                    "fields": ["name"],
                }
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(readURL, RepsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ Reps: data.result });
                        localStorage.setItem('Reps', JSON.stringify(this.state.Reps));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, skillsBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ skills: data.result });
                        localStorage.setItem('Skills', JSON.stringify(this.state.skills));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
            await _post(readURL, currentRepBody).then((response) => {
                return response.json().then((data) => {
                    if (data.result !== undefined) {
                        this.setState({ currentRep: data.result[0].id });
                        localStorage.setItem('CurrentUserId', JSON.stringify(this.state.skills));
                    }
                    else {
                        this.setState({ alertUndefined: true });
                    }
                })
            })
        }
        else {
            const Reps = localStorage.getItem('Reps');
            const skills = localStorage.getItem('Skills');
            this.setState({ skills: JSON.parse(skills), Reps: JSON.parse(Reps) });
        }
    }

    closeAlertBack = () => {
        this.setState({ showAlertBack: false });
    }

    showAlertBack = () => {
        this.setState({ showAlertBack: true });
    }

    onGoBack = () => {
        this.props.history.push("./LandingPageRep");
    }

    onSync = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        await this.setState({ disableSync: true });

        const coach = localStorage.getItem('UnsyncedCoach');
        await this.setState({ USCoach2: JSON.parse(coach) });

        const createURL = constantURI() + "OdooController/CreateActivity";
        this.state.USCoach2.map(async (act, actIndex, actArr) => {
            if (this.state.authenticate) {
                await _post(createURL, act).then(async (response) => {
                    return response.json().then(async (data) => {
                        if (data.result !== undefined) {
                            localStorage.setItem('UnsyncedCoachCount', JSON.stringify(0));
                            localStorage.setItem('UnsyncedCoach', JSON.stringify([]));
                            alert("Synced Successfully");
                            this.props.history.push("./LandingPageRep");
                        }
                        else {
                            this.setState({ alertUndefined: true });
                        }
                    })
                })
            }
            else if (!this.state.authenticate && actIndex === actArr.length - 1) {
                alert("Only sync when connected to the Internet!");
                await this.setState({ disableSync: false });
            }
        })
    }

    onSave = async () => {
        await Authenticate().then((response) => { this.setState({ authenticate: response }) });
        await this.setState({ disableSave: true });
        var coach = (this.state.USCoach === null || this.state.USCoach === []) ? [] : this.state.USCoach;

        const createURL = constantURI() + "OdooController/CreateActivity"
        const coachBody = {
            "jsonrpc": "2.0",
            "params": {
                "method": "create",
                "model": "coaching",
                "args": [
                    {
                        supervisor_id: this.state.currentRep,
                        rep_id: Number(this.state.selectedRep),
                        status: "requested",
                        date: this.state.date.toISOString().substring(0, 10),
                        skill: Number(this.state.selectedSkill),
                        remark: this.state.remark,
                    }
                ],
                "kwargs": {}
            },
            "token": this.state.token
        }
        if (this.state.authenticate) {
            await _post(createURL, coachBody).then((response) => {
                return response.json().then((data) => {
                    this.props.history.push("/LandingPageRep");
                })
            })
        }
        else {
            await coach.push(coachBody);
            await this.setState({ coachCount: this.state.coachCount + 1 });
            await localStorage.setItem('UnsyncedCoach', JSON.stringify(coach));
            await localStorage.setItem('UnsyncedCoachCount', JSON.stringify(this.state.coachCount));
            await alert("This Day is not uploaded to Odoo due to internet disconnection. Sync when reconnected.");
            this.props.history.push("./LandingPageRep");
        }

    }

    onChangeSelectedRep = async (e) => {
        await this.setState({ selectedRep: e.target.value });
    }

    onChangeSelectedSkill = async (e) => {
        await this.setState({ selectedSkill: e.target.value });
    }

    onChangeRemark = (e) => {
        this.setState({ remark: e.target.value });
    }

    render() {
        return (
            <div className="container-fluid vh-100" style={stylesMed.mainBackgroundColor}>
                {(this.state.coachCount === 0 || this.state.coachCount === null) ?
                    <div className="alert alert-secondary">You have 0 planned coaching days to sync with Odoo.</div> :
                    <div className="col alert alert-danger">You have {this.state.coachCount} planned coaching days to sync with Odoo.
                          <div className="row">
                            <h5 className="col-sm-8">Only sync when connected to the Internet!</h5>
                            <div className="col-sm-4 d-flex flex-row-reverse">
                                <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onSync}>
                                    Sync Planned Visits</div>
                            </div>
                        </div>
                    </div>
                }
                {(!this.state.alertUndefined) ?
                    null :
                    <div className="col alert alert-danger">
                        <div className="row">
                            <h6 className="col-sm-8">There seems to be a problem.</h6>
                            <div className="col d-flex flex-row-reverse">
                                <div className={(this.state.disableSync) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={() => window.location.reload()}>
                                    Reload</div>
                            </div>
                        </div>
                    </div>
                }
                <div className="row pt-3">
                    <div className="col">
                        <ArrowBackCircle className="btn" onClick={() => this.showAlertBack()} color={'#00bfff'} height="50px" width="50px" />
                    </div>
                    <div className="col text-center"><h5 style={stylesMed.visitTitle}>Coaching Planner</h5></div>
                    <div className="col d-flex flex-row-reverse">
                        <div className={(this.state.disableSave) ? "btn disabled" : "btn"} style={stylesMed.wideButton} onClick={this.onSave}>Save Coaching</div>
                    </div>
                </div>
                <Modal show={this.state.showAlertBack} onHide={this.closeAlertBack} animation={false}>
                    <Modal.Header>
                        <Modal.Title>Save changes?</Modal.Title>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="btn" data-toggle="modal" data-target="#myModal" style={stylesMed.wideButton} onClick={this.onSave}>Save</div>
                        <div className="btn btn-secondary" data-toggle="modal" data-target="#myModal" style={stylesMed.cancelWideButton}
                            onClick={() => this.onGoBack()}>Discard</div>
                    </Modal.Footer>
                </Modal>
                <div className="p-4" style={stylesMed.plannerCardBackgroundColor}>
                    <div className="row">
                        <div className="col">
                            <h6>Select a Representative:</h6>
                            <select className="form-control" id="sel1" value={this.state.selectedRep}
                                onChange={this.onChangeSelectedRep} name="sellist1" style={stylesMed.planInput}>
                                <option value=""></option>
                                {this.state.Reps.map((item, index) => {
                                    return (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="col">
                            <h6>Select a Date: </h6>
                            <DatePicker className="form-control" style={{ width: "200px" }} selected={this.state.date}
                                onChange={(date) => this.setState({ date: date })} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col">
                            <h6>Select a Skill:</h6>
                            <select className="form-control" id="sel1" value={this.state.selectedSkill}
                                onChange={this.onChangeSelectedSkill} name="sellist1" style={stylesMed.planInput}>
                                <option value=""></option>
                                {this.state.skills.map((item, index) => {
                                    return (
                                        <option key={index} value={item.id}>{item.name}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="col">
                            <h6>Remarks: </h6>
                            <textarea className="form-control" value={this.state.remark} onChange={this.onChangeRemark} style={stylesMed.reportClientInput} />
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}